import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import React, { Component } from 'react';
import { CancelPenalty } from '../../../../component';
import { WarningIcon } from '~svg';

class FlightCancelRules extends Component {
  constructor(props) {
    super(props);
  }
  returnExactTimeMsg = (item) => {
    if (item)
      return item.isExactTime
        ? `12:00  ${this.props.intl.formatMessage({ id: 'booking.exacttime' })}`
        : this.returnHourMsg(item);
  };
  returnHourMsg = (item) => {
    if (item)
      return item.hourBefore
        ? item.minutesBefore
          ? `${item.hourBefore} ${this.props.intl.formatMessage({
              id: 'booking.hours',
            })} ${item.minutesBefore} ${this.props.intl.formatMessage({
              id: 'booking.minutes',
            })} `
          : `${item.hourBefore} ${this.props.intl.formatMessage({
              id: 'booking.hours',
            })}`
        : item.minutesBefore
        ? `${item.minutesBefore} ${this.props.intl.formatMessage({
            id: 'booking.minutes',
          })}`
        : '';
  };
  returnDayBeforeMsg = (item) => {
    if (item)
      return item.dayBefore
        ? `${item.dayBefore}  ${this.props.intl.formatMessage({
            id: 'booking.day',
          })}  ${this.props.intl.formatMessage({ id: 'booking.before' })}`
        : this.props.intl.formatMessage({ id: 'booking.beforeflight' });
  };
  createCancelRulesMessage = (item, index, cancelingRule) => {
    if (item) {
      if (item.penalty === 100) {
        return this.props.intl.formatMessage({
          id: 'booking.notrefundable',
        });
      } else if (
        item.dayBefore === 0 &&
        item.hourBefore === 0 &&
        item.minutesBefore === 0 &&
        !item.isExactTime
      ) {
        return this.props.intl.formatMessage({
          id: 'booking.missflight',
        });
      } else {
        if (
          index === cancelingRule.length - 1 &&
          !item.dayBefore &&
          !item.hourBefore &&
          !item.minutesBefore &&
          !item.isExactTime
        )
          return ` ${this.props.intl.formatMessage({
            id: 'booking.fromhours',
          })} ${this.returnExactTimeMsg(
            index === 0 ? cancelingRule[index] : cancelingRule[index - 1],
          )} ${this.returnDayBeforeMsg(
            index === 0 ? cancelingRule[index] : cancelingRule[index - 1],
          )} ${this.props.intl.formatMessage({ id: 'booking.after' })}`;
        else
          return (
            (item.dayBefore || item.hourBefore || item.minutesBefore) &&
            ` ${this.props.intl.formatMessage({ id: 'booking.until' })} 
    ${this.returnExactTimeMsg(item)} ${this.returnDayBeforeMsg(item)}`
          );
      }
    }
  };

  render() {
    let {
      cancelingRuleText,
      cancelingRule,
      noCancelRules,
      miniRulesPriceText,
      isMobile = false,
      darkMode = false,
    } = this.props;
    return (
      <React.Fragment>
        {cancelingRule?.length ? (
          <div
            style={{ zIndex: 1 }}
            className={`d-flex  w-100 p-0 m-0 align-items-center  ${
              isMobile
                ? 'font-smaller flex-row justify-content-start overflow-auto '
                : 'font-medium flex-wrap justify-content-center  '
            }`}
          >
            {cancelingRule.map((item, index) => {
              return (
                <div
                  className={`d-flex bg-transparent border border-1 border-muted default-border-radius-small flex-column justify-content-center align-items-center m-2 px-0 col-4 font-weight-bold`}
                  style={{ height: isMobile ? 100 : 115 }}
                  key={`cancelrule${index}`}
                >
                  <CancelPenalty
                    message={this.createCancelRulesMessage(
                      item,
                      index,
                      cancelingRule,
                    )}
                    percentage={item.penalty}
                    isMobile={isMobile}
                    darkMode={darkMode}
                  />
                </div>
                // <div
                //   className="d-flex card flex-column justify-content-center align-items-center m-2 px-0 col-5 font-weight-bold"
                //   style={{ height: isMobile ? 100 : 115 }}
                //   key={`cancelrule${index}`}>
                //   <div className="d-flex px-1 text-dark  justify-content-center align-items-center text-center w-100 text-lowercase flex-grow-1 ">
                //     {this.createCancelRulesMessage(item, index, cancelingRule)}
                //   </div>
                //   <div className="d-flex text-white bg-danger py-2 justify-content-center align-items-end  text-center w-100 px-0">
                //     {`${item.penalty}%`}
                //   </div>
                // </div>
              );
            })}
          </div>
        ) : null}
        {cancelingRuleText && cancelingRuleText !== '' && (
          <pre
            className={`d-flex col-12  text-left ${
              darkMode ? 'text-white' : 'text-dark'
            } font-smaller text-capitalize pre-wrap border border-1 mt-2`}
          >
            {cancelingRuleText}
          </pre>
        )}
        {miniRulesPriceText && (
          <div className="d-flex text-left col-12 my-2 flex-wrap ">
            {miniRulesPriceText.map((item, index) => (
              <pre
                className={`text-left  ${
                  darkMode ? 'text-white' : 'text-dark'
                } font-smaller text-capitalize border border-1 mt-2 pre-wrap w-100 p-1`}
                key={`flightRules-${index}`}
              >
                {item}
              </pre>
            ))}
          </div>
        )}
        {noCancelRules && noCancelRules.length && !miniRulesPriceText ? (
          <>
            <div className="modal-body px-3  font-smaller text-capitalize text-center">
              <div className="w-100  my-3">
                <WarningIcon
                  size={48}
                  color={'#ffc107'}
                  variant="svg-xxlarge svg-md-xxlarge"
                />
              </div>
              <span
                className={`${
                  isMobile
                    ? darkMode
                      ? 'text-dark'
                      : 'text-dark'
                    : 'text-muted'
                } ${isMobile ? 'font-small' : 'font-large'}
                font-weight-bold pt-4 text-uppercase`}
              >
                {noCancelRules}
              </span>
            </div>
          </>
        ) : (
          <></>
        )}
      </React.Fragment>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(connect(mapStateToProps)(FlightCancelRules));
